import { ArrowRight, ArrowRightLeft, EyeOff, Lock, ShieldCheck, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { eyebrow, h2Xl, leadText, textLink } from "./styles";

const FACTS = [
  { key: "encryption", Icon: Lock },
  { key: "transit", Icon: ArrowRightLeft },
  { key: "neverSold", Icon: ShieldCheck },
  { key: "aiContext", Icon: EyeOff },
  { key: "delete", Icon: Trash2 },
] as const;

const Privacy = () => {
  const { t } = useTranslation();
  return (
    <section id="security" aria-labelledby="sec-h" className="scroll-mt-[72px] px-[22px] py-[clamp(88px,9vw,128px)]">
      <div className="mx-auto max-w-[1200px]">
        <div className="pf-rv mx-auto max-w-[780px] text-center">
          <p className={eyebrow}>{t("home.privacy.eyebrow")}</p>
          <h2 id="sec-h" className={h2Xl}>
            {t("home.privacy.title")}
          </h2>
          <p className={`mx-auto mt-[22px] max-w-[560px] ${leadText}`}>{t("home.privacy.subtitle")}</p>
        </div>

        <ul className="pf-rv2 m-0 mt-[72px] grid list-none grid-cols-1 gap-6 p-0 md:grid-cols-3 md:gap-8 min-[1100px]:grid-cols-5">
          {FACTS.map(({ key, Icon }) => (
            <li key={key} className="border-t border-foreground/15 pt-6">
              <Icon aria-hidden="true" className="h-7 w-7 text-foreground" strokeWidth={1.4} />
              <h3 className="mt-4 text-[19px] font-semibold tracking-[-0.015em]">{t(`home.privacy.facts.${key}.title`)}</h3>
              <p className="mt-2 text-[15px] leading-normal text-pf-ink2">{t(`home.privacy.facts.${key}.body`)}</p>
            </li>
          ))}
        </ul>

        <p className="mt-12 text-center text-[17px]">
          <Link to="/security" className={textLink}>
            {t("home.privacy.link")}
            <ArrowRight aria-hidden="true" className="h-4 w-4 rtl:-scale-x-100" />
          </Link>
        </p>
      </div>
    </section>
  );
};

export default Privacy;
